export function getModifyBooleans(details) {
  // Business logic
  const modifyBooleans = {
    isModifyMainTemplate: false,
    isModifyMainPromo: false,
    isModifyOptInTemplate: false,
    isModifyOptInPromo: false,
    isModifyOptOutTemplate: false
  }

  const mainTemplateVars = [
    'messageTemplate',
    'customDeliveryStatus',
    'deliveryFinishDate',
    'deliveryStartDate',
    'isActive',
    'messageMediaUrls',
    'customUrl'
  ]

  const mainPromoVars = [
    'maxDiscountPercentage',
    'minNightsToStay',
    'promotionCode',
    'promotionTagline'
  ]

  const optinTemplateVars = [
    'optInAcceptResponseTemplate',
    'optInMediaUrls',
    'optInTemplate'
  ]

  const optinPromoVars = [
    'optInMinNightsToStay',
    'optInPromotionCode',
    'optInMaxDiscountPercentage'
  ]

  const optoutTemplateVars = ['optOutTemplate']

  if (Object.keys(details).some(r => mainTemplateVars.includes(r))) {
    modifyBooleans.isModifyMainTemplate = true
  }

  if (Object.keys(details).some(r => mainPromoVars.includes(r))) {
    modifyBooleans.isModifyMainPromo = true
  }

  if (Object.keys(details).some(r => optinTemplateVars.includes(r))) {
    modifyBooleans.isModifyOptInTemplate = true
  }

  if (Object.keys(details).some(r => optinPromoVars.includes(r))) {
    modifyBooleans.isModifyOptInPromo = true
  }

  if (Object.keys(details).some(r => optoutTemplateVars.includes(r))) {
    modifyBooleans.isModifyOptOutTemplate = true
  }

  return modifyBooleans
}
